import { parseDataAttribute } from './library'


jQuery($ => {
    const searchEndpoint = `/${currentEnvironment.language}/search_advance`;

    $('.overlay-content-slider').each( function(i, item){

        const section = $(item);
        const slider = section.find('.slider');
        $.get(searchEndpoint,
            {
                'type': JSON.stringify(parseDataAttribute(section.data('pagetype'))),
                't': JSON.stringify(parseDataAttribute(section.data('tags'))),
                'limit':section.data('limit')
            }, ({ data }) => {
            if (data && data.length > 0) {
                $.each(data, function (i, item ){
                    slider.append(`<a class="regular-card" href="${item.url}">
                <div class="regular-card__header">
                    <img class="regular-card__img" src="${item.image['480x270'] ?? item.image['348x164']}" alt="${item.headline}">
                    <img class="regular-card__icon" src="/assets/img/icons/icon_dark_${item.pageType}@3x.svg" alt="${item.pageType}">
                </div>
                <div class="regular-card__content">
                    <div class="regular-card__title">${item.headline}</div>
                    <div class="regular-card__tag">${item.tag}</div>
                    <div class="regular-card__date">${item.date}</div>
                </div>
            </a>`)
                });
                applySlider(slider);
            }
        }).fail(console.error);

    });

    $('#overlayModal').on('shown.bs.modal', () => {
        $('.overlay-slider').not('.slick-initialized').slick({
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            accessibility: false,
            prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><img src="/assets/img/icons/icon_light_arrowleft.svg" alt="Previous"/></button>',
            nextArrow: '<button class="slick-next" aria-label="Next" type="button"><img src="/assets/img/icons/icon_light_arrowright.svg" alt="Next"/></button>',
        });
    });
    function applySlider(elementName) {
        $(elementName).slick({
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        infinite: false,
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 650,
                    settings: {
                        infinite: false,
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ],
            prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><img src="/assets/img/icons/icon_light_arrowleft.svg" alt="Previous"/></button>',
            nextArrow: '<button class="slick-next" aria-label="Next" type="button"><img src="/assets/img/icons/icon_light_arrowright.svg" alt="Next"/></button>',
        });
    }
});
